import { getAccountId, getUrlWithSearchParams, membersLink } from "@helium10/re-core";
import type { StringifiableRecord } from "query-string";
import { generatePath, matchPath } from "react-router-dom";

export const customerLink = membersLink + "/api/v1/customers/me";
export const subscribeLink = membersLink + "/subscribe";

export const supportLink = "https://kb.helium10.com/hc/en-us/requests/new";
export const tokenManagerListLink = membersLink + "/new-account/tokens-manager-list";

export const mrsLink = "/managed-refund-service";

export const onboardingRoute = mrsLink + "/onboarding";
export const acceptFeeTermsRoute = mrsLink + "/feeTerms";
export const landingRoute = mrsLink + "/landing";
export const StrictRestrictRoutes = [onboardingRoute, acceptFeeTermsRoute, landingRoute];

/** 仅用于 pathname 等价比较：移除多余尾部斜杠，使 `/foo` 与 `/foo/` 一致；根 `/` 不变 */
function normalizePathnameTrailingSlashes(path: string): string {
  if (path.length > 1 && path.endsWith("/")) {
    return path.replace(/\/+$/, "");
  }
  return path;
}
/** pathname 是否与某常量路由等价（尾随斜杠不敏感）；不含 basename / 子挂载场景，需在应用与常量一致时使用 */
export function pathnameMatchesRoute(pathname: string, route: string): boolean {
  return normalizePathnameTrailingSlashes(pathname) === normalizePathnameTrailingSlashes(route);
}
/** 是否与 StrictRestrictRoutes 中任一路由等价（尾随斜杠不敏感）；子路径如 …/onboarding/x 不匹配 */
export function isStrictRestrictPathname(pathname: string): boolean {
  return StrictRestrictRoutes.some((route) => pathnameMatchesRoute(pathname, route));
}

/** 是否在 onboarding 列表页或单 seller 入驻子路径（尾随斜杠不敏感） */
export function isOnboardingAreaPathname(pathname: string): boolean {
  const normalized = normalizePathnameTrailingSlashes(pathname);
  return (
    pathnameMatchesRoute(normalized, onboardingRoute) ||
    Boolean(matchPath({ path: `${onboardingRoute}/:sellerId`, end: true }, normalized))
  );
}

export const claimCasesRoute = mrsLink + "/claim_cases";
export const inboundRoute = mrsLink + "/inbound";
export const documentCenterRoute = mrsLink + "/documentCenter";
export const billingRoute = mrsLink + "/billing";
export const packFeeRoute = mrsLink + "/packFee";
export const refundGenieRoute = mrsLink + "/refundGenie";
export const inboundAccountRoute = mrsLink + "/inboundAccount";

export const getRedirectMrsRoute = (accountId: string) => generatePath(mrsLink, { accountId });

export const getRedirectRoute = (route: string) => {
  const accountId = getAccountId();
  return generatePath(route, { accountId });
};

export const goToOnboarding = () => {
  return getUrlWithSearchParams(onboardingRoute, {}, { hasAccountId: true });
};

export const goToAcceptFeeTerms = () => {
  return getUrlWithSearchParams(acceptFeeTermsRoute, {}, { hasAccountId: true });
};

export const goToLanding = () => {
  return getUrlWithSearchParams(landingRoute, {}, { hasAccountId: true });
};

export const goToInbound = (queryParamsProps?: StringifiableRecord) => {
  return getUrlWithSearchParams(inboundRoute, queryParamsProps || {}, { hasAccountId: true });
};

export const goToMrs = () => {
  return getUrlWithSearchParams(mrsLink, {}, { hasAccountId: true });
};

export const goToMemberspage = () => {
  const accountId = getAccountId();
  window.location.href =
    "https://pages.helium10.com/refund-service-demo?medium=direct&source=memberspage&campaign=solution-refunds&content=mrsdemo&accountId=" +
    accountId;
};
